
/* injects from baggage-loader */

'use strict';

import { find, filter, fill, pick, clone, last } from 'lodash';

import { resetText } from './tamandua-canvas.const';

export default class TamanduaCanvasController {
    constructor($log, $rootScope, $scope, $timeout, $interval, hotkeys, Dialog) {
        'ngInject';
        this.$log = $log;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$interval = $interval;
        this.hotkeys = hotkeys;
        this.Dialog = Dialog;

        this.player = null;
        this.maxSequence = 16;
        this.isBotStarted = false;
    }

    $onInit(){
        this.selectPlayer(0);

        this.listRows = fill(Array(this.rows), null);
        this.listColumns = fill(Array(this.columns), null);

        this.hotkeys.bindTo(this.$scope)
            .add({
                combo: 'up',
                callback: () => !this.isBotStarted ? this.moveTop() : false
            })
            .add({
                combo: 'down',
                callback: () => !this.isBotStarted ? this.moveBottom() : false
            })
            .add({
                combo: 'left',
                callback: () => !this.isBotStarted ? this.moveLeft() : false
            })
            .add({
                combo: 'right',
                callback: () => !this.isBotStarted ? this.moveRight() : false
            });
        
        this.$scope.$watch('$ctrl.player.position.x', () => {
            if(!this.player || !this.player.position) return;
            let { position } = this.player;
            return position.x === this.columns && position.y === this.rows 
                ? this.$timeout(this.onFinishCanvas.bind(this)) 
                : false
        });
        
        this.$scope.$watch('$ctrl.player.position.y', () => {
            if(!this.player || !this.player.position) return;            
            let { position } = this.player;
            return position.x === this.columns && position.y === this.rows 
                ? this.$timeout(this.onFinishCanvas.bind(this)) 
                : false
        });

        this.$rootScope.$on('tamandua-canvas:select:player', (event, playerIndex) => {
            this.selectPlayer(playerIndex);
        });

        this.$rootScope.$on('tamandua-canvas:start:bot', (event, sequence) => {
            this.executeSequence(sequence);
        });
    }

    // Events
    onFinishCanvas(){
        this.player.complete = true
        this.player.onDone();
    }

    registerSquadTrail(position){
        let squad = find(this.squads, { position: position });

        let player = pick(this.player, ['type']);

        // Se não houver nenhum jogador deste tipo cadastrado adiciona a referência do mesmo.
        !find(squad.players, { type: player.type }) 
            ? squad.players.push(player)
            : false            

        return {squad, player};
    }

    registerPlayerTrail(direction){
        switch (direction) {
            case 'top':
                this.player.events.top++;
                break;
            case 'bottom':
                this.player.events.bottom++;
                break;
            case 'left':
                this.player.events.left++;
                break;
            case 'right':
                this.player.events.right++;
                break;        
            default:
                break;
        }

        if (this.player.sequence.length >= this.maxSequence){
            this.triggerReset();
        }
        
        // Agrupando sequência de passos
        let lastSequence = last(this.player.sequence);
        
        if (lastSequence) {
            // Verifica se a nova direção é diferente da última
            lastSequence.type !== direction
                ? this.player.sequence.push({ type: direction, value: 1 }) // Cria uma nova sequência
                : lastSequence.value++ // Icrementa valor da atual
        } else {
            // Se não existir nenhuma sequência
            this.player.sequence.push({
                type: direction,
                value: 1
            });
        }
        
        return this.player;
    }

    // Bot
    executeSequence(sequence){
        let position = 0;
        let intervalID = this.$interval(() => {
            this.moveBot(sequence[position]);
            
            position++;
            
            if(position >= ( sequence.length -1 )){
                this.isBotStarted = false;
                this.$interval.cancel(intervalID);
            }
        }, 400);
    }

    moveBot(direction){
        switch (direction) {
            case "right":
                this.moveRight()
                break;
            case "bottom":
                this.moveBottom()
                break;        
        }
    }

    // Squads

    inSquad(player, squad){
        return this.isCoordsEqual(player.position, squad.position);
    }

    isCoordsEqual(p1, p2){
        if(p1 && p2){
            return ( p1.x === p2.x ) && ( p1.y === p2.y );
        } else{
            return false;
        }
    }

    nextSquadHasTrash(direction){        
        if (!this.player.position) return false; // If player not initialized

        let position = clone(this.player.position);

        switch (direction) {
            case 'top':
                position.y--;
                break;
            case 'bottom':
                position.y++
                break;
            case 'left':
                position.x--;
                break;
            case 'right':
                position.x++;
                break;        
        }


        let squad = find(this.squads, { position: position });

        this.$log.log(squad);

        return squad.objects.length ? true : false
    }

    squadHasTypeA(squad){
        if (squad.players.length >= 2) return false;
        return filter(squad.players, { type: "A" }).length ? true : false;
    }
    
    squadHasTypeB(squad){
        if (squad.players.length >= 2) return false;
        return filter(squad.players, { type: "B" }).length ? true : false;
    }

    squadHasBothType(squad){
        return squad.players.length >= 2 ? true : false;
    }

    // Players
    isPositionPlayerNull(player){
        return player.position === null;
    }

    selectPlayer(index){
        if(this.players[index].complete) return false;
        this.disablePlayers();
        this.player = this.players[index];
        this.player.selected = true;
    }

    disablePlayers(){
        this.players.forEach(player => {
            player.selected = false;
        });

        this.player = null;
    }

    initializePlayer(){
        this.player.position = {
            x: 1,
            y: 1
        }
    }

    moveRight(){
        if(this.disabled || this.blocked) return;

        let { position, complete } = this.player;

        if (complete) return;
        
        if (position && position.x >= 10) return;
        
        if (this.nextSquadHasTrash('right')) return;

        position ? position.x++ : this.initializePlayer();        

        this.registerSquadTrail(this.player.position);
        this.registerPlayerTrail("right");
    }
    moveLeft(){
        if (this.disabled || this.blocked) return;

        let { position, complete } = this.player;
        
        if(complete) return;

        if(!position || position.x <= 1) return;

        if (this.nextSquadHasTrash('left')) return;

        position.x--;

        this.registerSquadTrail(position);
        this.registerPlayerTrail("left");
    }
    moveTop(){
        if (this.disabled || this.blocked) return;

        let { position, complete } = this.player;

        if (complete) return;

        if (!position || position.y <= 1) return;

        if (this.nextSquadHasTrash('top')) return;

        position.y--;

        this.registerSquadTrail(position);
        this.registerPlayerTrail("top");
    }
    moveBottom(){
        if (this.disabled || this.blocked) return;

        let { position, complete } = this.player;

        if (complete) return;

        if(!position || position.y >= 5) return;

        if(this.nextSquadHasTrash('bottom')) return;

        position.y++;

        this.registerSquadTrail(position);
        this.registerPlayerTrail("bottom");
    }

    triggerReset(){
        this.blocked = true;
        
        this.Dialog.showFeedback('label-opa', resetText, 'btn-ok', () => {
            this.onReset();
            
            this.selectPlayer(0);

            this.blocked = false;
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/tamandua-canvas/tamandua-canvas.controller.js